import type {
  RaspadinhaDayWinningSchedule,
  RaspadinhaTimeSlotWinner,
} from '@/types/raspadinha-campaign'
import { parseWinningTimeToMinutes } from './generate-random-winning-times'
import { formatCampaignDateLabel, buildCampaignDayNumberByDate } from './date-winning-schedules'

export type RaspadinhaCampaignWinnerRow = {
  winner: RaspadinhaTimeSlotWinner
  date: string
  dateLabel: string
  slotId: string
  slotTime: string
  slotTimeSortValue: number
  slotIsActive: boolean
}

function getSlotTimeSortValue(time: string): number {
  const minutes = parseWinningTimeToMinutes(time)
  return minutes ?? Number.MAX_SAFE_INTEGER
}

export function collectCampaignWinners(
  schedules: RaspadinhaDayWinningSchedule[]
): RaspadinhaCampaignWinnerRow[] {
  const rows: RaspadinhaCampaignWinnerRow[] = []

  const dayNumberByDate = buildCampaignDayNumberByDate(schedules)

  for (const schedule of schedules) {
    const dayNumber = dayNumberByDate.get(schedule.date)
    const dateLabel = formatCampaignDateLabel(schedule.date, dayNumber)

    for (const slot of schedule.time_slots) {
      for (const winner of slot.winners) {
        rows.push({
          winner,
          date: schedule.date,
          dateLabel,
          slotId: slot.id,
          slotTime: slot.time,
          slotTimeSortValue: getSlotTimeSortValue(slot.time),
          slotIsActive: slot.is_active,
        })
      }
    }
  }

  return rows.sort((left, right) => {
    if (left.date !== right.date) {
      return left.date.localeCompare(right.date)
    }

    if (left.slotTimeSortValue !== right.slotTimeSortValue) {
      return left.slotTimeSortValue - right.slotTimeSortValue
    }

    return left.winner.name.localeCompare(right.winner.name, 'pt-BR', { sensitivity: 'base' })
  })
}
